let createStandardEventForm = require("../../createStandardEventForm");

module.exports = createStandardEventForm({
	eventToInitialValues(event){
		return {
			nearestAirport: event.nearestAirport,
			travelAgent: event.travelAgent,
			travelNotes: event.travelNotes
		};
	},
	buildSchema(){
		return {
			nearestAirport: {
				label: "Nearest Airport",
				type: "text"
			},
			travelAgent: {
				label: "Travel Agent",
				type: "text",
			},
			travelNotes: {
				label: "Travel Notes",
				type: "textarea"
			}
		};
	},
	writeInputDataToEvent(data, event){
		event.nearestAirport = data.nearestAirport;
		event.travelAgent = data.travelAgent;
		event.travelNotes = data.travelNotes;
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/travel/TravelNotes.js